import { Injectable, Inject, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Router, CanActivate } from '@angular/router';
//import { environment } from '../../environments/environment';
import { NgxSpinnerService } from "ngx-spinner";

import { LoginService } from './login.service';

const STORAGE_KEY = '24ieye';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    public baseUrl: any;
    projectData: EventEmitter<any> = new EventEmitter();

    constructor(private login: LoginService, private httpClient: HttpClient, private router: Router, private spinner: NgxSpinnerService, private titleService: Title, @Inject('BASE_URL') baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    canActivate(): boolean {
        if (this.login.get_session_data('ieye_session_id') === null) {
            return true;
        } else {
            this.router.navigate(['projects']);
            return false;
        }
    }

    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    get_app_action_url(key) {
        var urls = {
            login: this.baseUrl + '/login',
            add_project: this.baseUrl + '/projects/add',
            edit_project: this.baseUrl + '/projects/edit',
            projects: this.baseUrl + '/projects',
            mentions: this.baseUrl + '/mentions',
            project_options: this.baseUrl + '/projects/options',
            users: this.baseUrl + '/users',
            add_user: this.baseUrl + '/users/add',
            edit_user: this.baseUrl + '/users/edit',
            get_data: this.baseUrl + '/users/get_data',
            delete_user: this.baseUrl + '/users/remove',
            hold_user: this.baseUrl + '/users/hold',
            unhold_user: this.baseUrl + '/users/unhold',
            delete_project: this.baseUrl + '/projects/remove',
            hold_project: this.baseUrl + '/projects/hold',
            unhold_project: this.baseUrl + '/projects/unhold',
            get_project: this.baseUrl + '/projects/row-data',
            excel_report: this.baseUrl + '/excel-report',
            change_password: this.baseUrl + '/users/change-password',
            pdf_report: this.baseUrl + '/pdf-report',
            activities: this.baseUrl + '/actions',
            login_failures: this.baseUrl + '/actions/login-failures',
            delete_failures: this.baseUrl + '/actions/delete-failures',
            block_mention: this.baseUrl + '/actions/block-mention',
            mention_view: this.baseUrl + '/actions/view-mention',
            mention_notification_email: this.baseUrl + '/notifications/mention-email-notification',
            keyword_settings: this.baseUrl + '/email-report/keyword-settings',
            source_settings: this.baseUrl + '/email-report/source-settings',
            report_settings: this.baseUrl + '/email-report/report-settings',
            notification_settings: this.baseUrl + '/email-report/notification-settings',
            get_report_settings: this.baseUrl + '/email-report/settings',
            add_tag: this.baseUrl + '/email-report/add-tag',
            is_active_user: this.baseUrl + '/users/is-active',
            translation: this.baseUrl + '/translation/convert',
            countries: 'https://restcountries.com/v3/all',
            mention_image: this.baseUrl + '/mentions/mention_image',
        }
        return urls[key];
    }

    public async form_actions(data, key) {
        return new Promise(resolve => {
            this.httpClient.post(this.get_app_action_url(key), data).subscribe((res: any) => {
                if (res.error == false) {
                    resolve(res);
                } else {
                    resolve(res);
                }
            }, err => {
                resolve('error');
            });
        });
    }

    public async form_post_actions(data, key) {
        return new Promise(resolve => {
            this.httpClient.post(this.baseUrl + key, data).subscribe((res: any) => {
                if (res.error == false) {
                    resolve(res);
                } else {
                    resolve(res);
                }
            }, err => {
                resolve('error');
            });
        });
    }

    public async get_actions(data, key) {
        return new Promise(resolve => {
            this.httpClient.get(this.get_app_action_url(key), data).subscribe((res: any) => {
                if (res.error == false) {
                    resolve(res);
                } else {
                    resolve(res);
                }
            }, err => {
                resolve('error');
            });
        });
    }

    public async common_actions(data, url) {
        return new Promise(resolve => {
            this.httpClient.post(url, data).subscribe((res: any) => {
                if (res.error == false) {
                    resolve(res);
                } else {
                    resolve(res);
                }
            }, err => {
                resolve('error '+ JSON.stringify(err));
            });
        });
    }

    public saveDateRange(start, end) {
        localStorage.setItem('ieye_session_start_date', start);
        localStorage.setItem('ieye_session_end_date', end);
    }

}
